import { useCallback } from 'react'
import * as XLSX from '@e965/xlsx'

export type Options = {
  title?: string | null | undefined
}

const useExport = ({ title }: Options = {}) => {
  const tableExport = useCallback((element: HTMLTableElement) => {
    const workbook = XLSX.utils.book_new()
    const sheet = XLSX.utils.json_to_sheet([])
    XLSX.utils.book_append_sheet(workbook, sheet)

    if (title) XLSX.utils.sheet_add_aoa(sheet, [[title]])

    XLSX.utils.sheet_add_dom(sheet, element, { raw: true, origin: 'A3' })

    XLSX.writeFileXLSX(workbook, [title || 'export', 'xlsx'].join('.'))
  }, [])

  return tableExport
}

export default useExport
